<template>
  <!-- 预约成功弹窗 -->
  <van-overlay :show="successVisible" z-index="100">
    <div class="success-modal">
      <div class="success-modal__inner">
        <img src="../assets/logo.png" alt="" class="success-modal__img" />
        <span class="success-modal__title">预约成功</span>
        <p>
          您已成功预约
          <span class="success-modal__date">{{ successDateText }}</span>
          号位，请于就诊日当天携带相关证件到医院取号就医。
        </p>
        <p class="success-modal__tip">
          特别提示：逾期到诊需提前联系改约，否则预约号作废。无故爽约达到3次，取消预约资格3个月。
        </p>
        <van-button type="primary" round block @click="successVisible = false">确定</van-button>
      </div>
    </div>
  </van-overlay>

  <!-- 主页面 -->
  <div class="home">
    <div class="card">
      <!-- 顶部标题栏 -->
      <div class="card__top">
        <img :src="logoSrc" alt="" class="card__top-logo" />
        <span class="card__top-title">自助预约挂号中心</span>
      </div>

      <!-- 表单 -->
      <div class="card__form">
        <!-- 标签行 -->
        <div class="tag-row">
          <div class="tag-radio tag-radio--checked">
            <div class="tag-radio__icon tag-radio__icon--checked">
              <van-icon name="success" color="#fff" size="12px" />
            </div>
            <span class="tag-radio__label"><b>挂号单</b></span>
          </div>
        </div>

        <van-cell-group :border="false">
          <!-- 就诊姓名 -->
          <van-field
            v-model="form.name"
            label="就诊姓名："
            placeholder="请输入姓名"
            :formatter="nameFormatter"
            format-trigger="onChange"
          />

          <!-- 性别 -->
          <van-field label="性别：" :border="false">
            <template #input>
              <van-radio-group v-model="form.sex" direction="horizontal">
                <van-radio :name="1">男</van-radio>
                <van-radio :name="2">女</van-radio>
              </van-radio-group>
            </template>
          </van-field>

          <!-- 年龄 -->
          <van-field
            v-model="form.age"
            label="年龄："
            placeholder="请输入年龄"
            type="digit"
          />

          <!-- 联系电话 -->
          <van-field
            v-model="form.tel"
            label="联系电话："
            placeholder="请输入电话"
            type="tel"
          />

          <!-- 就诊类型（仅初诊，不可切换） -->
          <van-field label="就诊类型：" :border="false">
            <template #input>
              <van-radio-group v-model="form.visitType" direction="horizontal">
                <van-radio :name="1">初诊</van-radio>
              </van-radio-group>
            </template>
          </van-field>

          <!-- 支付类型 -->
          <van-field label="支付类型：" :border="false">
            <template #input>
              <van-radio-group v-model="form.paymentType" direction="horizontal">
                <van-radio :name="1">非医保</van-radio>
                <van-radio :name="2">医保</van-radio>
              </van-radio-group>
            </template>
          </van-field>

          <!-- 身份证 -->
          <van-field
            v-model="form.idCard"
            label="身份证："
            placeholder="请输入身份证号"
          />

          <!-- 挂号费（仅显示，根据支付类型联动，不可手动切换） -->
          <van-field label="挂号费：" :border="false">
            <template #input>
              <van-radio-group v-model="form.payPrice" direction="horizontal">
                <van-radio :name="1500" :disabled="form.paymentType === 2">15元</van-radio>
                <van-radio :name="1260" :disabled="form.paymentType === 1">12.6元</van-radio>
              </van-radio-group>
            </template>
          </van-field>

          <!-- 就诊日期 -->
          <van-field
            v-model="form.visitDateText"
            label="就诊日期："
            placeholder="请选择日期"
            readonly
            clickable
            @click="showDatePicker = true"
          />

          <!-- 就诊时间 -->
          <van-field
            v-model="form.visitTime"
            label="就诊时间："
            placeholder="请选择时间"
            readonly
            clickable
            @click="showTimePicker = true"
          />

          <!-- 预约科室 -->
          <van-field
            v-model="form.departmentText"
            label="预约科室："
            placeholder="请选择科室"
            readonly
            clickable
            @click="showDeptPicker = true"
          />

          <!-- 客服电话 -->
          <van-cell
            icon="phone-o"
            @click="callService"
            style="cursor: pointer"
          >
            <template #title>
              <span class="contact-text">客服电话：022-58926611</span>
            </template>
          </van-cell>

          <!-- 医院地址 -->
          <van-cell icon="location-o">
            <template #title>
              <span class="contact-text">医院地址：天津市南开区玉泉路96号</span>
            </template>
          </van-cell>
        </van-cell-group>

        <!-- 提交按钮 -->
        <div class="submit-wrap">
          <van-button
            type="primary"
            round
            block
            :loading="submitting"
            loading-text="提交中..."
            @click="handleSubmit"
          >
            提交信息
          </van-button>
        </div>
      </div>
    </div>
  </div>

  <!-- 日期选择弹窗 -->
  <van-popup v-model:show="showDatePicker" position="bottom" round>
    <van-date-picker
      v-model="pickerDate"
      title="选择就诊日期"
      :min-date="minDate"
      :max-date="maxDate"
      @confirm="onDateConfirm"
      @cancel="showDatePicker = false"
    />
  </van-popup>

  <!-- 时间段选择弹窗 -->
  <van-popup v-model:show="showTimePicker" position="bottom" round>
    <van-picker
      :columns="timeSlots"
      title="选择就诊时间"
      @confirm="onTimeConfirm"
      @cancel="showTimePicker = false"
    />
  </van-popup>

  <!-- 科室选择弹窗 -->
  <van-popup v-model:show="showDeptPicker" position="bottom" round>
    <van-picker
      :columns="departments"
      title="选择预约科室"
      @confirm="onDeptConfirm"
      @cancel="showDeptPicker = false"
    />
  </van-popup>
</template>

<script>
import { defineComponent, ref, reactive, watch, onMounted } from 'vue'
import { showToast } from 'vant'
import { createOrder, payOrder, getOpenid } from '../api/guahao.js'
import { isWeixin, getCookie, setCookie, getUrlCode, isChinaIDCard, callpay, buildOAuthUrl } from '../utils/weixin.js'
import logoSrc from '../assets/logo.png'

const TIME_SLOTS = [
  { text: '8:00-9:00',   value: '8:00-9:00' },
  { text: '9:00-10:00',  value: '9:00-10:00' },
  { text: '10:00-11:00', value: '10:00-11:00' },
  { text: '11:00-12:00', value: '11:00-12:00' },
  { text: '13:00-14:00', value: '13:00-14:00' },
  { text: '14:00-15:00', value: '14:00-15:00' },
  { text: '15:00-16:00', value: '15:00-16:00' },
  { text: '16:00-17:00', value: '16:00-17:00' },
]

const DEPARTMENTS = [
  { text: '临床心理门诊',     value: '临床心理门诊' },
  { text: '精神科门诊',       value: '精神科门诊' },
  { text: '青少年心理门诊',   value: '青少年心理门诊' },
  { text: '抑郁焦虑障碍门诊', value: '抑郁焦虑障碍门诊' },
  { text: '睡眠医学中心',     value: '睡眠医学中心' },
  { text: '身心医学门诊',     value: '身心医学门诊' },
  { text: '成瘾医学门诊',     value: '成瘾医学门诊' },
  { text: '神经调控门诊',     value: '神经调控门诊' },
  { text: '中西医结合门诊',   value: '中西医结合门诊' },
]

export default defineComponent({
  name: 'GuahaoPage',

  setup() {
    // ===================== 表单数据 =====================
    const form = reactive({
      name: '',
      sex: 1,           // 1=男 2=女
      age: '',
      tel: '',
      idCard: '',
      visitType: 1,     // 固定初诊
      paymentType: 1,   // 1=非医保 2=医保
      payPrice: 1500,   // 单位：分
      visitDate: '',    // YYYY-MM-DD
      visitDateText: '', // 显示用
      visitTime: '',    // 如 "9:00-10:00"
      department: '临床心理门诊',
      departmentText: '临床心理门诊',
    })

    // 支付类型联动挂号费
    watch(() => form.paymentType, (type) => {
      form.payPrice = type === 2 ? 1260 : 1500
    })

    // 姓名过滤数字
    function nameFormatter(val) {
      return val.replace(/\d/g, '')
    }

    // ===================== 弹窗控制 =====================
    const showDatePicker = ref(false)
    const showTimePicker = ref(false)
    const showDeptPicker = ref(false)
    const successVisible = ref(false)
    const successDateText = ref('')
    const submitting = ref(false)

    // DatePicker 绑定数组 [YYYY, MM, DD]
    const pickerDate = ref([
      String(new Date().getFullYear()),
      String(new Date().getMonth() + 1).padStart(2, '0'),
      String(new Date().getDate()).padStart(2, '0'),
    ])

    const minDate = new Date()
    const maxDate = new Date(Date.now() + 90 * 86400000)

    function onDateConfirm({ selectedValues }) {
      const [y, m, d] = selectedValues
      form.visitDate = `${y}-${m}-${d}`
      form.visitDateText = `${y}-${m}-${d}`
      showDatePicker.value = false
    }

    function onTimeConfirm({ selectedValues }) {
      form.visitTime = selectedValues[0]
      showTimePicker.value = false
    }

    function onDeptConfirm({ selectedValues }) {
      form.department = selectedValues[0]
      form.departmentText = selectedValues[0]
      showDeptPicker.value = false
    }

    // ===================== 表单校验 =====================
    function validate() {
      if (!form.name.trim()) { showToast('请输入就诊姓名'); return false }
      if (!form.age) { showToast('请输入年龄'); return false }
      if (!form.tel || !/^1[3-9]\d{9}$/.test(form.tel)) { showToast('请输入正确的11位手机号'); return false }
      if (form.paymentType === 2 && !isChinaIDCard(form.idCard)) {
        showToast('医保需要填写正确身份证号'); return false
      }
      if (!form.visitDate) { showToast('请选择就诊日期'); return false }
      if (!form.visitTime) { showToast('请选择就诊时间'); return false }
      return true
    }

    // ===================== 提交逻辑 =====================
    async function handleSubmit() {
      if (!isWeixin()) {
        showToast('请用微信打开！')
        return
      }
      if (!validate()) return

      submitting.value = true
      try {
        const openid = getCookie('openid') || ''
        if (!openid) {
          showToast('正在获取授权，请稍候重试')
          location.href = buildOAuthUrl()
          return
        }

        // Step 1: 创建订单
        const createResp = await createOrder({
          name: form.name.trim(),
          sex: form.sex,
          age: parseInt(form.age) || 0,
          tel: form.tel,
          idCard: form.idCard,
          visitType: form.visitType,
          paymentType: form.paymentType,
          payPrice: form.payPrice,
          visitDate: form.visitDate,
          visitTime: form.visitTime,
          department: form.department,
          openid,
        })

        if (createResp.code !== 0) {
          showToast(`预约失败：${createResp.msg || '未知错误'}`)
          return
        }

        const orderNo = createResp.data

        // Step 2: 发起支付
        const payResp = await payOrder({ orderNo, openid })
        if (payResp.code !== 0) {
          showToast(`发起支付失败：${payResp.msg || '未知错误'}`)
          return
        }

        // Step 3: 调起微信支付
        callpay(
          payResp.data,
          () => {
            // 支付成功
            successDateText.value = `${form.visitDateText} ${form.visitTime}`
            successVisible.value = true
          },
          () => {
            showToast('支付失败，请重试')
          }
        )
      } catch (e) {
        showToast('提交失败，请检查网络后重试')
        console.error(e)
      } finally {
        submitting.value = false
      }
    }

    function callService() {
      window.location.href = 'tel:022-58926611'
    }

    // ===================== 微信 OAuth 初始化 =====================
    async function initOpenid() {
      if (getCookie('openid')) return // 已有 openid，跳过
      if (!isWeixin()) return         // 非微信环境，不处理

      const code = getUrlCode()
      if (code) {
        // 清理 URL 中的 code（code 只能使用一次）
        const cleanUrl = location.href.replace(/[?&]code=[^&]+/, '').replace(/[?&]state=[^&]+/, '').replace(/\?$/, '')
        history.replaceState(null, '', cleanUrl)
        try {
          const resp = await getOpenid(code)
          if (resp.code === 0 && resp.data) {
            setCookie('openid', resp.data, 7)
          } else {
            console.error('换取 openid 失败', resp.msg)
          }
        } catch (e) {
          console.error('请求 getOpenid 接口出错', e)
        }
      } else {
        // 没有 code，跳转微信授权
        location.href = buildOAuthUrl()
      }
    }

    onMounted(initOpenid)

    return {
      form,
      logoSrc,
      nameFormatter,
      // 弹窗
      showDatePicker,
      showTimePicker,
      showDeptPicker,
      successVisible,
      successDateText,
      submitting,
      // picker 数据
      pickerDate,
      minDate,
      maxDate,
      timeSlots: TIME_SLOTS,
      departments: DEPARTMENTS,
      // 事件
      onDateConfirm,
      onTimeConfirm,
      onDeptConfirm,
      handleSubmit,
      callService,
    }
  },
})
</script>

<style scoped>
/* ===== 页面布局 ===== */
.home {
  padding: 16px;
  min-height: 100vh;
}

/* ===== 卡片 ===== */
.card {
  border-radius: 5px;
  background-color: #fff;
  overflow: hidden;
}

/* ===== 顶部标题 ===== */
.card__top {
  background-color: #f7f7f7;
  padding: 16px;
  display: flex;
  align-items: center;
}
.card__top-logo {
  display: block;
  height: 18px;
}
.card__top-title {
  color: #07c160;
  font-size: 18px;
  font-weight: 700;
  margin-left: 5px;
  line-height: 1;
}

/* ===== 表单区域 ===== */
.card__form {
  padding: 0;
}

/* ===== 挂号单标签 ===== */
.tag-row {
  padding: 8px 16px;
}
.tag-radio {
  display: inline-flex;
  align-items: center;
  border: 1px solid #ebedf0;
  border-radius: 5px;
  padding: 6px 12px;
  gap: 6px;
}
.tag-radio__icon {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 1px solid #c8c9cc;
  display: flex;
  align-items: center;
  justify-content: center;
}
.tag-radio__icon--checked {
  background-color: #07c160;
  border-color: #07c160;
}
.tag-radio__label {
  font-size: 16px;
  color: #333;
  font-weight: 700;
}

/* ===== van-cell 字体统一 ===== */
:deep(.van-cell) {
  font-size: 16px;
  color: #333;
  padding: 12px 16px;
}
:deep(.van-field__label) {
  width: 90px;
  color: #333;
  font-size: 16px;
}

/* ===== 联系信息 ===== */
.contact-text {
  font-size: 15px;
  color: #323233;
}

/* ===== 提交按钮 ===== */
.submit-wrap {
  padding: 16px;
}
:deep(.submit-wrap .van-button--primary) {
  background-color: #07c160;
  border-color: #07c160;
}

/* ===== 预约成功弹窗 ===== */
.success-modal {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.success-modal__inner {
  background: #fff;
  border-radius: 12px;
  padding: 28px 24px;
  margin: 0 24px;
  text-align: center;
}
.success-modal__img {
  width: 56px;
  height: 56px;
  margin-bottom: 12px;
}
.success-modal__title {
  display: block;
  font-size: 20px;
  font-weight: 700;
  color: #333;
  margin-bottom: 16px;
}
.success-modal__date {
  color: #07c160;
  font-weight: 600;
}
.success-modal__tip {
  font-size: 13px;
  color: #888;
  margin-top: 10px;
  margin-bottom: 20px;
  text-align: left;
  line-height: 1.6;
}
</style>
